<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>添加预约</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="back">返回</el-button>
      </div>
      <el-form label-position="right" label-width="80px" class="form">
        <el-form-item label="课程时间" class="box">
          <el-date-picker
            v-model="startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="微信名称" class="box">
          <el-input v-model="userData.nickName" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="box">
          <el-input v-model="userData.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="box">
          <el-input v-model="userData.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址" class="box">
          <el-input v-model="userData.addr" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程类型" class="box">
          <el-select
            class="wd100"
            v-model="courseVal"
            placeholder="请选择"
            @change="getCourseName(courseVal)"
          >
            <el-option
              v-for="item in courseType"
              :key="item.val"
              :label="item.label"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约类型" class="box">
          <el-select class="wd100" v-model="orderType" placeholder="请选择">
            <el-option
              v-for="item in orderTypes"
              :key="item.val"
              :label="item.label"
              :value="item.val"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约人数" class="box">
          <el-input v-model="teamNumber"></el-input>
        </el-form-item>
        <el-form-item label="预约课时" class="box">
          <el-select class="wd100" v-model="classHourId" placeholder="请选择">
            <el-option
              v-for="item in classHour"
              :key="item.id"
              :label="item.dictValue"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程安排" class="box">
          <el-select
            class="wd50 mr"
            v-model="bigVal"
            placeholder="请选择"
            @change="getSmallType(bigVal)"
          >
            <el-option
              v-for="item in bigType"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            ></el-option>
          </el-select>
          <el-select class="wd50" v-model="smallVal" placeholder="请选择">
            <el-option
              v-for="item in smallType"
              :key="item.id"
              :label="item.dictValue"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教练安排" class="box">
          <el-select class="wd100" v-model="coachVal" placeholder="请选择">
            <el-option
              v-for="item in coachs"
              :key="item.id"
              :label="item.coachName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="saveBtn" @click="commit" type="primary">添加预约</el-button>
        <el-button class="saveBtn" @click="back" type="primary">返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      formData: [],
      userData: {},
      bigVal: "",
      smallVal: "",
      bigType: [],
      smallType: [],
      coachVal: "",
      coachs: [],
      loading: false,
      courseType: [
        { label: "训练课程", val: "XLKC" },
        { label: "中医诊疗", val: "ZYZL" }
      ],
      courseVal: "",
      classHour: [],
      orderTypes: [
        { label: "个人预约", val: "1" },
        { label: "团体预约", val: "0" }
      ],
      startTime: "",
      nickName: "",
      userName: "",
      mobile: "",
      addr: "",
      courseName: "",
      orderType: "",
      teamNumber: "",
      classHourId: "",
      userId: this.$route.query.id
    };
  },
  mounted() {
    this.getUser();
    this.getCoach();
    this.getClassHour();
  },
  methods: {
    commit() {
      var that = this;
      let id = this.$route.query.id;
      if (
        that.startTime &&
        that.courseName &&
        that.orderType &&
        that.teamNumber &&
        that.classHourId &&
        that.coachVal &&
        that.smallVal
      ) {
        that
          .$confirm("请确认预约信息是否正确？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          })
          .then(() => {
            that.$axios
              .post(this.baseUrl + "/adminAddOrder", {
              // .post("/gymTest/adminAddOrder", {
                createTime: that.startTime,
                orderType: that.orderType,
                courseName: that.courseName,
                teamNumber: that.teamNumber,
                classHourId: that.classHourId,
                coachId: that.coachVal,
                parentCourseId: that.smallType[0].dicParentId,
                courseId: that.smallVal,
                userId: that.userId
              })
              .then(res => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$notify({
                    title: "提交成功",
                    message: "已成功预约课程！",
                    type: "success"
                  });
                  that.$router.go(-1);
                } else {
                  that.$notify.error({
                    title: "预约失败",
                    message: res.data.message
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
      } else {
        that.$notify.error({
          title: "预约失败",
          message: "请选择填写完整的信息"
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    getBigType(val) {
      console.log(val);
      var that = this;
      that.smallType = [];
      that.smallVal = "";
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          console.log(res);
          that.bigType = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getSmallType(val) {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          console.log(res);
          that.smallType = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCoach() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryCoach", {})
        // .get("/gymTest/queryCoach", {})
        .then(res => {
          console.log(res);
          that.coachs = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程种类id
    getCourseName(val) {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          that.courseName = res.data.id;
          that.bigVal = "";
          that.getBigType(that.courseName);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程时长
    getClassHour() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: "class-hour"
          }
        })
        .then(res => {
          that.getClassHourId(res.data.id);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程时长id
    getClassHourId(val) {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          that.classHour = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取用户详情
    getUser() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryWxUser", {
        // .get("/gymTest/queryWxUser", {
          params: {
            userId: that.userId
          }
        })
        .then(res => {
          that.userData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.form {
  overflow: hidden;
}
.box {
  width: 48%;
  float: left;
}
.wd50 {
  width: 47%;
}
.wd100 {
  width: 100%;
}
.mr {
  margin-right: 6%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.btn-box {
  text-align: center;
  margin: 20px auto;
}
</style>
